import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import TeamInvite from '@/pages/organizations/detail/team/invite'

export const Route = createFileRoute('/app/organizations/$organizationId/team/invite')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { organization } = useOrganization()
  return <TeamInvite organization={organization} />
}
